<template>
    <div>
        <div class="d-flex align-items-center">
            <h3 class="title-content">Veículos Ativos</h3>
        </div>
        <div class="active-vehicles">
            <active-vehicles></active-vehicles>
        </div>

    </div>
</template>

<script>
    import ActiveVehicles from '../components/ActiveVehicles'
    export default {
        components: {ActiveVehicles},
        data:function () {
            return{
            }
        },
    };
</script>

<style scoped>
    .active-vehicles{
        margin-bottom: 20px;
    }
</style>
